import { LineSheet } from "../LineSheet";

const buildColumns = (lookups) => [
  { key: "group", label: "Group Name (Quality)", width: 180, options: lookups.groups, upper: true },
  { key: "company", label: "Company", width: 200, options: lookups.companies, upper: true },
  { key: "item", label: "Item Name", width: 240, options: lookups.items, upper: true },
  { key: "shade", label: "Shade", width: 110 },
  { key: "quantity", label: "Qty (Than)", width: 120, numeric: true },
  { key: "date", label: "Date *", width: 130, required: true },
];

export default function WholesaleCompanyOrder() {
  return (
    <LineSheet
      sheetKey="wholesale-company-order-rows"
      prefix="wco-"
      title="Wholesale Company Order"
      subtitle="Orders sent to the company for the shop / office — date is compulsory (DD/MM/YYYY)"
      headerColor="#0E7490"
      defaultGroup=""
      columnsOverride={buildColumns}
    />
  );
}
